import { forwardRef } from 'react';
import clsx from 'clsx';

export const Select = forwardRef(function Select(
  { label, error, hint, className, id, options = [], children, ...rest },
  ref
) {
  const inputId = id || rest.name || crypto.randomUUID();
  return (
    <div className="flex flex-col gap-1.5">
      {label && (
        <label htmlFor={inputId} className="text-sm font-medium text-ink">
          {label}
        </label>
      )}
      <select
        id={inputId}
        ref={ref}
        className={clsx(
          'h-9 rounded-md border bg-surface-elevated px-3 text-sm text-ink',
          'transition-colors',
          error ? 'border-danger' : 'border-border-strong focus:border-ink',
          'focus:outline-none focus:ring-2 focus:ring-ink/10',
          className
        )}
        {...rest}
      >
        {options.length > 0
          ? options.map((opt) => (
              <option key={opt.value} value={opt.value}>{opt.label}</option>
            ))
          : children}
      </select>
      {error ? (
        <span className="text-xs text-danger">{error}</span>
      ) : hint ? (
        <span className="text-xs text-ink-muted">{hint}</span>
      ) : null}
    </div>
  );
});
